export default class FinesseCarousel extends HTMLElement {
  index: number = 0
  total: number = 0
  dotItems: HTMLElement[] = []

  constructor() {
    super()

    this.className = 'relative block'

    this.dotItems = Array.from(this.querySelectorAll<HTMLElement>('button[data-item]'))

    if (this.dotItems.length > 0) {
      this.dotItems.forEach((dot) => {
        dot.addEventListener('click', this.handleDotClick.bind(this))
      })
    }


    this.total = this.dotItems.length

    const imageList = this.querySelector('ul[data-image-list]')
    if (imageList) {
      const options = {
        root: imageList,
        rootMargin: '0px',
        threshold: 0.5
      }

      let timeout: number| null = null

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = parseInt(entry.target.getAttribute('data-image') || '0')
          const dot = this.dotItems[index]

          if (entry.isIntersecting) {
            entry.target.setAttribute('data-active', 'true')
            dot.setAttribute('data-active', 'true')
            
          } else {
            entry.target.setAttribute('data-active', 'false')
            dot.setAttribute('data-active', 'false')
          }

          if (timeout) {
            clearTimeout(timeout)
          }

          timeout = setTimeout(() => {
            this.updateActiveDot()
          }, 80)
        })
      }, options)

      const images = this.querySelectorAll('li[data-image]')
      images.forEach((image) => {
        observer.observe(image)
      })
    }

    setTimeout(() => {
      this.updateActiveDot(0)
    }, 1000)
  }

  handleDotClick(evt: Event) {
    evt.preventDefault()

    const dot = evt.target as HTMLElement
    const index = dot.dataset.item

    const image = this.querySelector(`li[data-image="${index}"]`)
    const imageList = this.querySelector('ul[data-image-list]')
    
    if (image && imageList) {
      const imageRect = image.getBoundingClientRect()
      const listRect = imageList.getBoundingClientRect()
      
      imageList.scrollTo({
        left: imageRect.left - listRect.left + imageList.scrollLeft,
        behavior: 'smooth'
      })
    }
  }

  connectedCallback() {
    console.log('carousel added')
  }

  updateActiveDot() {
    this.dotItems.forEach((dot) => {
      const dotActive = dot.dataset.active === 'true'

      if (dotActive) {
        dot.classList.add('bg-black')
      } else {
        dot.classList.remove('bg-black')
      }
    })
  }
}

customElements.define('finesse-carousel', FinesseCarousel)
